
import { Vue } from 'vue-property-decorator';

export default class App extends Vue {
  public ERCodeLocation: string = `url(//game.weixin.qq.com/cgi-bin/comm/qrcode?s=10&m=1&d=${encodeURIComponent(
    window.location.href
  )})`;
}
